"use client";

import { Tooltip, Button } from "antd";
import { IconLocation } from "@/lib/icons";
import { useRouter } from "next/navigation";

const LocationButton = ({
  place_id,
  venue_name = "",
  is_public = false,
  inDetail = false,
}) => {
  const router = useRouter();
  const handleRedirect = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (is_public === false || inDetail === true) {
      const query = encodeURIComponent(venue_name || "Venue");
      const url = place_id
        ? `https://www.google.com/maps/search/?api=1&query=${query}&query_place_id=${place_id}`
        : `https://www.google.com/maps/search/?api=1&query=${query}`;
      window.open(url, "_blank");
    } else {
      router.push(`/venue/${place_id}`);
    }
  };
  return (
    <Tooltip title={is_public === true ? "" : "View on Google Maps"}>
      <Button
        variant="filled"
        onClick={handleRedirect}
        color="default"
        icon={<IconLocation size={18} />}
        shape="circle"
        aria-label="View on Google Maps"
        style={{
          marginLeft: "auto",
          lineHeight: 1,
          flexShrink: 0,
          backgroundColor: "#f3f6f9",
          borderColor: "transparent",
          color: "#021526",
          width: 36,
          height: 36,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </Tooltip>
  );
};

export default LocationButton;
